import { render, staticRenderFns } from "./create-edit.vue?vue&type=template&id=589fa1be"
import script from "./create-edit.vue?vue&type=script&lang=js"
export * from "./create-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports